module.exports = __webpack_public_path__ + "img/profile.c57ff325.jpg";